import { render, staticRenderFns } from "./AggregatedHealthStates.global.vue?vue&type=template&id=d861fad2&lang=pug&"
import script from "./AggregatedHealthStates.global.vue?vue&type=script&lang=ts&"
export * from "./AggregatedHealthStates.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports